module.exports = __webpack_public_path__ + "static/media/milo-and-lisa.c512c10b.jpg";